<section class="w-full">
  <p class="text-4xl font-normal mt-[0.9rem]">Check In</p>
  <form [formGroup]="checkInForm" (ngSubmit)="checkIn()">
    <div class="flex mt-5">
      <div class="w-full xl:w-2/5 2xl:w-2/5">
        <tui-combo-box
          formControlName="client"
          [tuiTextfieldLabelOutside]="true"
          [stringify]="stringifyClients"
          placeholder="Select Client"
          >Select Client
          <tui-data-list-wrapper
            *tuiDataList
            [items]="clients | tuiFilterByInput"
            [itemContent]="stringifyClients | tuiStringifyContent"
          >
          </tui-data-list-wrapper>
        </tui-combo-box>
        <tui-error class="mb-3" [error]="[] | tuiFieldError | async" />

        <tui-combo-box [stringify]="stringifyDropdown" formControlName="roster">
          Select Roster
          <input tuiTextfieldLegacy placeholder="Select Roster" />
          <tui-data-list-wrapper
            *tuiDataList
            [items]="rosterItems"
            [itemContent]="stringifyDropdown | tuiStringifyContent"
          />
        </tui-combo-box>
        <tui-error formControlName="roster" class="mb-3" [error]="[] | tuiFieldError | async" />

        <tui-combo-box [stringify]="stringifyDropdown" formControlName="mealOption">
          Select Meal Option
          <input tuiTextfieldLegacy placeholder="Select Roster" />
          <tui-data-list-wrapper
            *tuiDataList
            [items]="mealOptions"
            [itemContent]="stringifyDropdown | tuiStringifyContent"
          />
        </tui-combo-box>
        <tui-error formControlName="mealOption" class="mb-3" [error]="[] | tuiFieldError | async" />

        <tui-combo-box [stringify]="stringifyDropdown" formControlName="typeOption" class="mb-3">
          Select Type
          <input tuiTextfieldLegacy placeholder="Select Type" />
          <tui-data-list-wrapper
            *tuiDataList
            [items]="typeOptions"
            [itemContent]="stringifyDropdown | tuiStringifyContent"
          />
        </tui-combo-box>
        <tui-error formControlName="typeOption" class="mb-3" [error]="[] | tuiFieldError | async" />

        <div class="w-full">
          <label tuiLabel>
            <tui-textarea
              formControlName="address"
              [tuiTextfieldLabelOutside]="true"
              placeholder="Enter Address"
              title="Textarea Input"
            >
              Address
            </tui-textarea>
            <tui-error formControlName="address" class="mb-3" [error]="[] | tuiFieldError | async" />
          </label>
        </div>
        
        <div class="mt-5 space-x-5 flex justify-end">
          <button
            [routerLink]="['/nurse/nurse-profile/', nurseId]"
            appearance="outline"
            tuiButton
            type="button"
            class="bg-black"
          >
            Cancel
          </button>
          <button
            appearance="primary"
            tuiButton
            type="submit"
            class="w-[180px]"
            title="Submit"
            [disabled]="isLoading"
          >
            Check In
          </button>
        </div>
      </div>
    </div>
  </form>
</section>
